import React, { useState } from "react";
import './MoveItemModal.css';

const MoveItemModal = ({ item, onClose, onConfirm }) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showConfirmationForm, setShowConfirmationForm] = useState(false);

  // Campos editables para completar
  const [overrideBrand, setOverrideBrand] = useState("");
  const [overrideModel, setOverrideModel] = useState("");
  const [overrideStatus, setOverrideStatus] = useState("");
  const [overrideWarrantyDate, setOverrideWarrantyDate] = useState("");
  const [overrideReturnableDate, setOverrideReturnableDate] = useState("");
  const [overrideNotes, setOverrideNotes] = useState("");


  if (!item || !item.__typename) return null;

  const currentSection = item.__typename.replace("Fix", "");
  const options =
    currentSection === "Supplies"
      ? [{ value: "generalInventory", label: "Other Equipment" }]
      : [{ value: "supplies", label: "Office Supplies" }];

  const missingFields = [];
  if (!item.brand) missingFields.push("Brand");
  if (!item.model) missingFields.push("Model");
  if (!item.status) missingFields.push("Status");
  if (!item.warranty_date) missingFields.push("Warranty date");
  if (!item.returnable_date) missingFields.push("Returnable Date");
  if (!item.notes) missingFields.push("Notes");



  const handleSubmit = () => {

    if (!selectedCategory) {
      alert("Please select the category");
      return;
    }

    const updatedItem = {
      ...item,
      brand: overrideBrand || item.brand || null,
      model: overrideModel || item.model || null,
      status: overrideStatus || item.status || null,
      warranty_date: overrideWarrantyDate || item.warranty_date || null,
      returnable_date: overrideReturnableDate || item.returnable_date || null,
      notes: overrideNotes || item.notes || null,
    };

    onConfirm(updatedItem, selectedCategory);
    onClose();

  };

  return (
    <div className="move-overlay" onDoubleClick={(e) => {
      if (e.target.classList.contains("move-overlay")) {
        onClose();
      }
    }}>
      <div className="move-content">
        <h2 className="move-title">Move to another section</h2>

        <div className="move-select-group">
          <label htmlFor="category-select">Select new category:</label>
          <select
            id="category-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="" disabled hidden>
              -- Select a category --
            </option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

        </div>

        {/* Faltan campos y aún no se pidió completar */}
        {missingFields.length > 0 && !showConfirmationForm ? (
          <div className="warning-section">
            <p>⚠️ This item has missing fields:</p>
            <ul>
              {missingFields.map((field) => (
                <li key={field}>- {field}</li>
              ))}
            </ul>
            <p>Do you want to complete the fields before moving it?</p>
            <div>
              <button className="move-confirm" onClick={() => setShowConfirmationForm(true)}>
                Yes, complete
              </button>
              <button className="move-cancel" onClick={handleSubmit}>No, move as is</button>
            </div>
          </div>
        ) : null}

        {/* Formulario si eligió completar */}
        {showConfirmationForm && (
          <div className="form-section">
            <label>Brand:</label>
            <input
              type="text"
              value={overrideBrand}
              onChange={(e) => setOverrideBrand(e.target.value)}
            />

            <label>Model:</label>
            <input
              type="text"
              value={overrideModel}
              onChange={(e) => setOverrideModel(e.target.value)}
            />

            <label>Status:</label>
            <select
              name="status"
              value={overrideStatus}
              onChange={(e) => setOverrideStatus(e.target.value)}
            >
              <option value="" disabled hidden>
                Select Status
              </option>
              <option value="use">Use</option>
              <option value="broken">Broken</option>
              <option value="transfer">Transfer</option>
              <option value="lost">Lost</option>
              <option value="inv">Inventario</option>
            </select>

            <label>Warranty Date:</label>
            <input
              type="date"
              value={overrideWarrantyDate}
              onChange={(e) => setOverrideWarrantyDate(e.target.value)}
            />

            <label>Returnable Date:</label>
            <input
              type="date"
              value={overrideReturnableDate}
              onChange={(e) => setOverrideReturnableDate(e.target.value)}
            />

            <label>Notes:</label>
            <input
              type="text"
              value={overrideNotes}
              onChange={(e) => setOverrideNotes(e.target.value)}
            />

            <button className="move-confirm mt-3" onClick={handleSubmit}>
              Move with the new data
            </button>
          </div>
        )}

        {!showConfirmationForm && missingFields.length === 0 && (
          <div className="move-actions">
            <button className="move-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className="move-confirm"
              onClick={handleSubmit}
              disabled={!selectedCategory}
            >
              Confirm
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default MoveItemModal;


